import { X } from "lucide-react";

import { Button } from "@/components/ui/button";

import { useCallContext } from "./Call/CallContext";

export const CloseTabButton = () => {
  const { setActiveMode } = useCallContext();
  return (
    <Button
      size="sm"
      variant="secondary"
      onClick={() => setActiveMode("script")}
    >
      <X size={16} />
    </Button>
  );
};
